import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const MappedResultTab = ({
    rows,
    columns,
    notMappedFieldsSet,
    getRowClassName,
    handleDownload,
    showDownload
}) => {
    return (
        <>
            {showDownload && (
                <div
                    style={{
                        marginTop: 12,
                        marginBottom: 12,
                        minHeight: 40,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Button
                        visible={showDownload}
                        label="Download"
                        icon="pi pi-download"
                        className="p-button-success"
                        onClick={handleDownload}
                    />
                </div>
            )}

            <div
                style={{
                    maxHeight: '61vh',
                    minHeight: '20vh',
                    padding: 0,
                    margin: 0,
                    position: 'relative',
                    background: 'transparent',
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: '0.9em'
                }}
            >
                <div
                    style={{
                        flex: 1,
                        width: '100%',
                        height: '100%',
                        overflowX: 'auto',
                        overflowY: 'auto'
                    }}
                >
                    <DataTable
                        value={rows}
                        scrollable
                        style={{
                            fontSize: '0.9em',
                            padding: 0,
                            margin: 0,
                            lineHeight: 1.2,
                            minWidth: 'max-content'
                        }}
                        showGridlines
                        rowClassName={getRowClassName(rows)}
                    >
                        {columns.map(col => (
                            <Column
                                key={col}
                                field={col}
                                header={
                                    notMappedFieldsSet.has(col) ? (
                                        <span
                                            style={{
                                                background: '#f8d7da',
                                                color: '#721c24',
                                                padding: '2px 6px',
                                                borderRadius: 4,
                                                fontWeight: 600,
                                                fontSize: '0.95em'
                                            }}
                                        >
                                            {col}
                                        </span>
                                    ) : (
                                        <span
                                            style={{
                                                padding: '2px 6px',
                                                fontSize: '0.95em'
                                            }}
                                        >
                                            {col}
                                        </span>
                                    )
                                }
                                style={{
                                    minWidth: 100,
                                    padding: '2px 4px'
                                }}
                                headerStyle={{
                                    padding: '2px 4px'
                                }}
                            />
                        ))}
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default MappedResultTab;